import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The best 70 cents I have ever spent on the iStore",
  "description": "",
  "published": "2012-06-14T00:00:00.000Z",
  "redirect_from": ["/blog/the-best-70-cents-i-have-ever-spent-on-the-istore/swizec/4640"],
  "categories": "Alarm clock, Circadian rhythm, Sleep, SleepTime, Slow-wave sleep, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`Last night I cut the light off in my bedroom. Hit the switch, was in bed before the room was dark.`}</p>
      <p parentName="blockquote">{`~ Muhammad Ali`}</p>
    </blockquote>
    <p>{`When I was 5, my mum convinced me that if I ate pickles (I hated pickles) I wouldn't get sleepy and could stay up for new year's.`}</p>
    <p>{`Ate so many pickles that night - about a jar - that I fell in love with the taste ... and promptly slept through the night.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/photo-1.png",
        "alt": "Mad Men kept me up, then I plummeted into sleep",
        "title": "Mad Men kept me up, then I plummeted into sleep"
      }}></img></p>
    <p>{`Ok so pickles don't really work as a way to control sleep. Caffeine does a much better job, but it tends to be problematic as well. You get used to the darned thing and it stops working, plus mistiming the intake can cause devastating effects like making you crash right before an important deadline.`}</p>
    <p>{`No, you can't optimize sleep without measuring it.`}</p>
    <p>{`Enter `}<a parentName="p" {...{
        "href": "http://itunes.apple.com/us/app/sleep-time-alarm-clock-sleep/id498360026?mt=8"
      }}>{`Azumio's Sleep Time`}</a>{`, stage left.`}</p>
    <p>{`Almost a month ago Azumio's sleeping app replaced `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/sleep-hacking/swizec/2851",
        "title": "Sleep hacking"
      }}>{`the old app I was using`}</a>{`. Original impressions were that it is much shinier, the interface is better and the graphs it draws are prettier.`}</p>
    <p>{`But that's not the whole story, it works better too!`}</p>
    <p>{`I am notoriously bad with alarm clocks - even smart alarm clocks syncing up to my `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Circadian_rhythm",
        "title": "Circadian rhythm"
      }}>{`sleep cycle`}</a>{` aren't always successful. Heavy sleeper who consistently sleeps less than most consider "normal" isn't a very good combination. Sometimes I think you could drive a tank over my bed without waking me up.`}</p>
    <p>{`As a result, the old app was too confident - it would ring. Wait a bit. And stop tracking. "`}<em parentName="p">{`Of course he woke up! I rang didn't I!?"`}</em></p>
    <p>{`This lead to a loss of a lot of essential vital data. I hate losing data.`}</p>
    <p>{`Azumio's app continues collecting data and drawing pretty graphs until you convince it that you're awake. And it's not easily convinced!`}</p>
    <p>{`First stage of defense is the clever "snooze button" - you have to shake the phone violently until the app goes `}<em parentName="p">{`"ok ok, I get it, you want to snooze"`}</em>{`. Violent shaking tends to wake you up quite a bit.`}</p>
    <p>{`This can keep going ad nauseum and the app tells you nicely how many snoozes you endured. A useful metric ... I think.`}</p>
    <p>{`The final stage of defense is that you have to hold the `}<em parentName="p">{`"I promise I am awake now!"`}</em>{` button for two seconds before the app believes you. Turns out it's difficult to hold a button for that long unless you are actually awake.`}</p>
    <h2 {...{
      "id": "i-learned-stuff"
    }}>{`I learned stuff!`}</h2>
    <p>{`So far azumio's alarm clock has turned up a lot of useful info:`}</p>
    <ul>
      <li parentName="ul">{`I sleep like a log - on most nights I almost don't come out of deep sleep until it's wakeup time`}</li>
      <li parentName="ul">{`I am a snoozer - the last half hour to an hour of every night is spent essentially fully awake, except I don't remember anything and am fairly certain I'm asleep`}</li>
      <li parentName="ul">{`I fall asleep instantly - when I watch a movie to fall asleep, I spend ten to twenty minutes fully awake, then I am suddenly asleep. The transition usually takes less than three minutes.`}</li>
    </ul>
    <p>{`Especially that last discovery is interesting. I have always known it doesn't take me very long to fall asleep - seemingly a sign that I am using up my whole day very effectively - but I didn't think the transition was `}<em parentName="p">{`that`}</em>{` quick.`}</p>
    <p>{`All in all, the best money I have ever spent on the iStore.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/photo.png",
        "alt": "My usual night",
        "title": "My usual night"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://betakit.com/2012/05/03/sleep-apps-helping-people-get-a-good-nights-rest"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/87142251_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://betakit.com/2012/05/03/sleep-apps-helping-people-get-a-good-nights-rest"
        }}>{`Sleep Apps Helping People Get a Good Night's Rest`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://mashable.com/2012/03/28/sleeptime-app/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/82160843_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://mashable.com/2012/03/28/sleeptime-app/"
        }}>{`SleepTime Uses Your iPhone To Track Your Snooze `}{`[`}{`INVITES`}{`]`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://techcrunch.com/2012/03/28/azumio-sleep-time/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/82208557_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://techcrunch.com/2012/03/28/azumio-sleep-time/"
        }}>{`Hitting 20M Downloads, Azumio Releases Sleep Time To Measure Your Zs (From Your iPhone)`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://bigthink.com/ideas/7-technologies-to-help-you-sleep"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/88585834_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://bigthink.com/ideas/7-technologies-to-help-you-sleep"
        }}>{`7 Technologies to Help You Sleep Better`}</a></li>
    </ul>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=c8946200-2ef5-4834-84a5-fd3481441fdb",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      